import GenericGallery from "./GenericGallery";
import { constData } from "./Config";

const Const_client = () => (
  <GenericGallery 
    galleryData={constData} // Array de proyectos
    galleryType="construccion"
    baseRoute="/galeria-construccion"
  />
);

export default Const_client;